module.exports = __webpack_public_path__ + "img/Deathknight-nightelf-m-70.1da55fec.gif";